module.exports = __webpack_public_path__ + "static/media/p_4_0.3774608c.png";